import { Tag } from '@arrived/common';

export const tagIdFilterOptions = [
  { filter: null, label: { id: 'all', defaultMessage: 'All' } },
  {
    filter: Tag.APPRECIATION_FOCUSED,
    label: { id: 'appreciation-focused', defaultMessage: 'Appreciation Focused' },
  },
  {
    filter: Tag.BALANCED,
    label: { id: 'balanced', defaultMessage: 'Balanced' },
  },
  {
    filter: Tag.DIVIDEND_FOCUSED,
    label: { id: 'dividend-focused', defaultMessage: 'Dividend Focused' },
  },
] as const;
